const styles = theme => ({
  cover: {
    display: 'block',
    width: 140,
    height: 175,
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/ActionsDrawer/components/CandidateItem/components/ProfileImage/styles.js